import { Environment, Local } from "../api/encore-client";

/**
 * Returns the appropriate Encore environment based on NEXT_PUBLIC_NODE_ENV
 * Use this for consistent environment configuration across client and server components
 */
export function getEnvironmentConfig() {
  const env = process.env.NEXT_PUBLIC_NODE_ENV;

  // Define the hardcoded backend host URL for production/staging
  const backendHost = "https://api.ledgentic.com";

  let environment;
  if (env === "production") {
    environment = backendHost; // Use hardcoded host for production
  } else if (env === "staging") {
    environment = backendHost; // Use hardcoded host for staging
  } else {
    // Default to Local for development and test
    environment = Local;
  }

  return environment;
}

/**
 * Sets additional environment variables needed for Cloud Run deployment
 * Can be extended with other environment-specific configurations
 */
export function getCloudRunConfig() {
  const isCloudRun = process.env.NEXT_PUBLIC_IS_CLOUD_RUN === "true";

  // Add any Cloud Run specific environment variables here
  const config = {
    isCloudRun,
    // Add other Cloud Run specific configs as needed
  };

  return config;
}
